import React, { useState, useEffect } from 'react';
import classnames from 'classnames';

import Icon from 'dpl/common/components/Icon';
import BreederApplicationContainer from 'dpl/join_as_breeder/containers/BreederApplicationContainer';

import { BREEDER_JOIN_TITLE, BREEDER_JOIN_BODY } from '../utils/constants';

export default function MobileJoinBox() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    document.body.classList.add('mb15');

    return () => document.body.classList.remove('mb15');
  }, []);

  return (
    <div
      className={classnames(
        'GoodBreederCenterMobileJoinBox w-100 fixed bottom-0 iphone-notch-bottom z-max bg-blue-500 transition',
        {
          'GoodBreederCenterMobileJoinBox--closed': !isOpen
        }
      )}
    >
      <button
        className="w-100 ph5 pt4 pb6 flex align-items-center fw-medium white"
        onClick={() => setIsOpen(!isOpen)}
        type="button"
      >
        <span className="flex-auto">{BREEDER_JOIN_TITLE}</span>
        <Icon name={`fat-arrow-${isOpen ? 'down' : 'up'}`} />
      </button>

      <div className="ph5 pb6">
        <p className="mb4 f2 fw-medium white">{BREEDER_JOIN_BODY}</p>
        <BreederApplicationContainer
          className="GoodBreederCenterMobileJoinBox__button f2"
          variant="secondary"
        />
      </div>
    </div>
  );
}
